import React from 'react';

const Tag = (props) => {
  
    const style = { backgroundImage: `url(${props.imageSrc})` }

    return (
        <div className={`tag ${ props.activeClass }`} style={ style } onClick={ ()=>props.handleTagClick(props.tag) } >
          <span className="label">{ props.tag.label }</span>
        </div>
      )
  }

export default Tag;



// WEBPACK FOOTER //
// ./src/templates/Tag.js